import axiosInstance from "../../../../axiosInstance";
import { error } from "../../../../store/notification/actions";

export const addSessionData = ({ key, value }) => {
  sessionStorage.setItem(key, value);
};

export const removeSessionData = ({ key }) => {
  sessionStorage.removeItem(key);
};

export const getSessionData = ({ key }) => {
  return sessionStorage.getItem(key);
};

export const clearSessionData = () => {
  sessionStorage.clear();
};
export const addLocalStorageData = ({ key, value }) => {
  return localStorage.setItem(key, value)
}
export const removeLocalStorageData = ({ key }) => {
  return localStorage.removeItem(key)
}

export const getLocalStorageData = ({ key }) => {
  return localStorage.getItem(key)
}

export const getUserModules = (userId, storeId) => {
  return axiosInstance
    .post("/store/getModules", { user_id: userId, store_id: storeId })
    .then((res) => {
      if (res.data.status === "success") {
        return { message: "", hasError: false, data: res.data.data };
      } else {
        const errorMessage = res.data?.error[0]?.message;
        return {
          message: errorMessage,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response?.data?.error[0]?.message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};
